import { render, staticRenderFns } from "./part10.vue?vue&type=template&id=225fdc3b&"
import script from "./part10.vue?vue&type=script&lang=js&"
export * from "./part10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports